import { useState } from 'react';
import { DialogUI } from '../Interface';
import { CompanyPage } from './CompanyPage';
import { useFormikContext } from 'formik';
import { Box, Typography } from '@mui/material';
import { sxConfig } from '../Interface/interface.style';

const CompanyDialog = ({
  showDialog,
  onClose,
  selectedCompanyId = null,
  hideRightPanel = false,
  selectOnClose = true,
  initialAddMode = false,
}) => {
  const { values, setFieldValue } = useFormikContext();
  const [selectedCompany, setSelectedCompany] = useState(null);

  const handleClose = () => {
    if (onClose) {
      // ha nincs kiválasztott cikk, null-lal hívjuk vissza
      onClose(
        selectOnClose ? selectedCompany?.id ?? null : null,
        setFieldValue,
        selectedCompany?.id ?? selectedCompanyId ?? values.companyId ?? null
      );
    }
    // lokális állapot reset a következő nyitáshoz
    setSelectedCompany(null);
  };

  return (
    <DialogUI
      open={showDialog}
      headerContent={'Üzleti Partnerek'}
      fullWidth={true}
      onClose={handleClose}
      closeBtn={true}
      actionsContent={
        selectedCompany?.id ? (
          <Box sx={sxConfig.dialogActionContent}>
            <Typography variant="body2" noWrap sx={sxConfig.dialogActionContentTypography1}>
              Választott üzleti partner:
              <Box component="span" sx={sxConfig.dialogActionContentTypography2}>
                {selectedCompany?.name}
              </Box>
            </Typography>
          </Box>
        ) : null
      }
      maxWidth="xl"
    >
      {showDialog && (
        <CompanyPage
          fromDialog={true}
          dialogSetSelectedCompany={setSelectedCompany}
          selectedCompanyId={selectedCompanyId}
          hideRightPanel={hideRightPanel}
          initialAddMode={initialAddMode}
        />
      )}
    </DialogUI>
  );
};

export default CompanyDialog;
